import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=df257b2e&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=df257b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df257b2e",
  null
  
)

export default component.exports